import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    getCENSMEDashboardDetails,
    CENSMEDashboardDetailsModel,
} from "@tCentro/Services/CENSMEDashboardDetailsService";

type Props = HasOnSuccess<CENSMEDashboardDetailsModel>;

interface ReturnType {
    apiResult: CENSMEDashboardDetailsModel;
}

type HandlerType = ApiHandler<Props, ReturnType>;

export const GetCENSMEDashboardDetails: HandlerType = async props => {
    const result = await getCENSMEDashboardDetails();

    if (props.parameter.onSuccess) {
        props.parameter.onSuccess(result);
    }
};

export const chain = [GetCENSMEDashboardDetails];

const getCENSMEDashboardDetailsData = createHandlerChainRunner(chain, "getCENSMEDashboardDetailsData");
export default getCENSMEDashboardDetailsData;
